export const Role = {
    User: 'user',
    Rattacher: 'rattacher',
    Admin: 'admin',
};
